import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useOpenAuth } from './useAuthModal'

export function useAccountNavigation() {
	const navigate = useNavigate()
	const { user } = useAuth()
	const openAuth = useOpenAuth()

	return () => {
		if (user) {
			navigate('/account')
		} else {
			// Гостю — вход окном поверх страницы, как у остальных кнопок входа
			openAuth('/login')
		}
	}
}